<template>
  <v-checkbox :readonly="readonly" :label="prop.text" 
  v-model="model[`${prop.value}`]" :color="prop.color"></v-checkbox>
</template>
<style scoped>

</style>

<script>
  import Check from "./check.ts";
  export default Check;
</script>